
/*Global Ajax */

import $, { ajax } from 'jquery';

export function load_city_pricing()
{
	const select_field = document.querySelector('.module-property_management_pricing_widget__city-selection__select');
	const response_container = document.getElementById('module-property_management_pricing_widget__city-selection-output');
	const physical_locations = document.getElementById('module-property_management_pricing_widget__physical-locations');
	const features_container = document.getElementById('module-property_management_pricing_widget__features-lockup');

	if (typeof response_container == 'undefined' || response_container == null) return;

	const select_field_html = select_field.innerHTML;

	select_field.addEventListener('change', (e) =>
	{
		const post_id = e.target.value;

		$.ajax({
			url: Ajax.url,
			method: 'post',
			data: {
				action: 'load_city_pricing',
				post_id: post_id,
			},
			beforeSend: function ()
			{
				console.log('sending');
			},
			success: function (data)
			{
				let clean_res = JSON.parse(data);

				if (clean_res)
				{
					// $(physical_locations).fadeOut(400, function ()
					// {
					// 	$(this).remove();
					// });

					if (null === post_id || '' === post_id) {
						response_container.innerHTML = '';
					}
					else {
						response_container.innerHTML = clean_res.html;
					}
					physical_locations.innerHTML = clean_res.locations;
					features_container.innerHTML = clean_res.features;
					document.activeElement.blur();
				}

			},
			error: function (request, status, error)
			{
				console.log('error');
				console.log(request.readyState, request.resposnseText, status, error);
				response_container.text = 'Error';
			},
		})
	});
}



// WEBPACK FOOTER //
// ./scripts/modules/load-property-managment-pricing.js